import { Flex, Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { formatDate } from '@blockpulse3/helpers';

type Props = {
  date: Date;
};

/**
 * SubscriptionValidated.
 * Displays the details of subscription validated activity.
 */
export function SubscriptionCompleted({ date }: Props): JSX.Element {
  const i18nSubscriberDetailsSidePanel = useTranslations('SubscriberDetailsSidePanel');

  return (
    <Stack spacing={1}>
      <Text fontSize="sm">
        {i18nSubscriberDetailsSidePanel('Activity.SubscriptionCompleted.Title')}
      </Text>
      <Flex color="gray.500" justifyContent="space-between">
        <Text>{i18nSubscriberDetailsSidePanel('Activity.SubscriptionCompleted.Date')}:</Text>
        <Text>{formatDate(date, 'DD/MM/YYYY')}</Text>
      </Flex>
    </Stack>
  );
}
